/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageOrderCodeLabelColumn } from '../../../../components';
import { alteration } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getAlterationOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageAlterationsTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getAlterationOutput;
  columns: ManageOrderCodeLabelColumn[];
  onEdit: (alteration: alteration) => void;
  onDelete: (alteration: alteration) => void;
}

export const ManageAlterationsTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageAlterationsTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.alterations && data.alterations.items &&
          data.alterations.items.length > 0 &&
          data.alterations.items.map((alteration) => (
            <tr key={`row-${alteration.id}`}>
              <td>
                {alteration.order}
              </td>
              <td>
                {alteration.code}
              </td>
              <td>
                {alteration.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-alteration-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit alteration"
                  onClick={() => onEdit(alteration)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete alteration"
                  type="button"
                  onClick={() => onDelete(alteration)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.alterations ||
            !data.alterations.items ||
            data.alterations.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
